module.exports = __webpack_public_path__ + "static/media/UnderMaintenanceLogo.9062dc5c.svg";